import { useEffect, useState } from "react";

export const useHash = (initialHash: string)=> {
    const [hash, setHash] = useState(initialHash);

    useEffect(()=> {
        const onChange = ()=> {
            setHash(window.location.hash)
        }

        window.addEventListener('hashchange', onChange);

        return () => window.removeEventListener('hashchange', onChange);
    }, []);

    return hash;
}